(ns dre.modals.search.share.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.shared.interface.search.blunt :as blunt]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :search :share])

;; events

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db (merge 
        opts
        {:state nil
         :share-msg "Shared search"
         :entities []
         :selected-entities []})}))

(rf/reg-event-fx
 ::update-data
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [path value]]
  {:db (assoc-in db path value)}))

(rf/reg-event-fx
 ::get-entities 
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [query]]
   (if (> 3 (count query))
     {:db (assoc db :entities [])}
     {:db (assoc db :state :loading)
      ::network/request [{:endpoint :search/share-get-entities}
                         {:params {:search query}
                          :on-success [::success-get-entities]
                          :on-failure [::failure-get-entities]}]})))

(rf/reg-event-fx
 ::success-get-entities
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let [entities
        (mapv (fn [entity]
                (case (get entity :Type)
                  "user"
                  (let [division (get-in entity [:Division :Name])
                        client (get-in entity [:Division :Owner :Name])
                        p {:id (get entity :Id) 
                           :name (get entity :Name)
                           :label (str (get entity :FirstName) " " (get entity :LastName)
                                              " (" (get entity :Email) ")"
                                              " - " division)
                           :firstname (get entity :FirstName)
                           :lastname (get entity :LastName)
                           :email (get entity :Email)
                           :client client
                           :division division
                           :type "user"}]
                    (assoc p :value
                           (js/JSON.stringify
                            (clj->js (select-keys p [:name :firstname :lastname :email
                                                     :type :id])))))
                  "division"
                  (let [client-name (get-in entity [:Client :Name])
                        p {:id (get entity :Id) 
                           :name (get entity :Name)
                           :label (str (get entity :Name)
                                              (when client-name
                                                (str " at " client-name)))
                           :type "division"}]
                    (assoc p :value
                           (js/JSON.stringify
                            (clj->js (select-keys p [:name :type :id])))))
                  "team"
                  (let [p {:id (get entity :Id) 
                           :name (get entity :Name)
                           :label (get entity :Name)
                           :type "team"}]
                    (assoc p :value
                           (js/JSON.stringify
                            (clj->js (select-keys p [:name :type :id])))))
                  "client"
                  (let [p {:id (get entity :Id)
                           :name (get entity :Name)
                           :label (str (get entity :Name))
                           :type "client"}]
                    (assoc p :value
                           (js/JSON.stringify
                            (clj->js (select-keys p [:name :type :id])))))))
              (:body response))]
    {:db (assoc db
                :state :success
                :entities entities)})))

(rf/reg-event-fx
 ::failure-get-entities
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc db :state :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))

(rf/reg-event-fx
 ::share-query
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} _]
   (let [entities (map #(js/JSON.parse %) (:selected-entities db))
         query (:search-query db)
         title (:share-msg db)
         blunt (blunt/print (:query/pills query))
         order (:query/order query)
         params {:entities entities
                 :title title
                 :blunt blunt
                 :order order}]
     {::network/request [{:endpoint :search/share}
                         {:body params
                          :on-success [::modals/clear]}]})))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

